<template>
  <div>
    <div class="field">
      <div class="no-margin emoji-container">
        <div v-for="emoji in emojis" :key="emoji.value" @click="selectEmoji(emoji)">
          <a class="button emoji-fixed-width">
            <span>{{emoji.emoji}}</span>
          </a>
        </div>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
export default {
  name: 'Emojis',
  props: {
    emojis: Array,
    visible: Boolean
  },
  data () {
    return {
    }
  },
  methods: {
    selectEmoji (emoji) {
      this.$emit('emoji-selected', emoji.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/Emojis.vue